<ng-content></ng-content>

<datalist [attr.id]="searchbox?.list" *ngIf="autocomplete$ | async as connotes">
  <option *ngFor="let connote of connotes; trackBy: trackAutoCompleteOptions" [value]="connote.control_no">{{ connote.customer?.company_name }}</option>
</datalist>
